
import { createClient } from '@supabase/supabase-js';

// Helper function to safely access environment variables in different environments (Vite, CRA, Next.js)
const getEnvVar = (key: string): string => {
  // Check import.meta.env (Vite)
  try {
    // @ts-ignore
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key]) {
      // @ts-ignore
      return import.meta.env[key];
    }
  } catch (e) {
    // Ignore error
  }

  // Check process.env (Node/CRA/Webpack)
  try {
    if (typeof process !== 'undefined' && process.env && process.env[key]) {
      return process.env[key];
    }
  } catch (e) {
    // Ignore error
  }

  return '';
};

// Use provided credentials as fallback if environment variables are not set
const PROVIDED_URL = 'https://faevreppgferbintlgkr.supabase.co';
const PROVIDED_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZhZXZyZXBwZ2ZlcmJpbnRsZ2tyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQyNjI4NDgsImV4cCI6MjA3OTgzODg0OH0.I6GZsp9eQ_6nxnErkrj6oyktXxIbqSPQdv6rQdee_m8';

const supabaseUrl = (getEnvVar('VITE_SUPABASE_URL') || getEnvVar('REACT_APP_SUPABASE_URL') || PROVIDED_URL).trim();
const supabaseAnonKey = (getEnvVar('VITE_SUPABASE_ANON_KEY') || getEnvVar('REACT_APP_SUPABASE_ANON_KEY') || PROVIDED_KEY).trim();

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey);

// Log warning if keys are actually missing (should not happen now with fallbacks)
if (!isSupabaseConfigured) {
  console.warn('⚠️ Supabase credentials missing.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
